module.exports = __webpack_public_path__ + "img/mobile scanner stand15.0183fe96.jpg";